const state = {
  list: [
    // {id: 0, mAccountType: 2, mButtonControl: 0, mCreateTime: 1525230719000, mIcon: '', mLevel: 1, mName: '首页', mStatus: 1, mSupId: 0, mSupName: '', mTop: 1}
    // {id: 0, icon: '&#xe6d0;', name: '首页', Grade: 1},
    // {id: 1, icon: '&#xe6d0;', name: '组织管理', Grade: 1},
    // {id: 2, icon: '&#xe6d0;', name: '文档管理', Grade: 1},
    // {id: 3, icon: '&#xe6d0;', name: '教务管理', Grade: 1},
    // {id: 4, icon: '&#xe6d0;', name: '实习管理', Grade: 1},
    // {id: 5, icon: '&#xe6d0;', name: '咨询管理', Grade: 1},
    // {id: 6, icon: '&#xe6d0;', name: '系统管理', Grade: 1},
    // {id: 7, icon: '&#xe6d0;', name: '统计', Grade: 2, parent: 0},
    // {id: 8, icon: '&#xe6d0;', name: '待处理', Grade: 2, parent: 0},
    // {id: 9, icon: '&#xe6d0;', name: '部门管理', Grade: 2, parent: 1},
    // {id: 10, icon: '&#xe6d0;', name: '岗位管理', Grade: 2, parent: 1},
    // {id: 11, icon: '&#xe6d0;', name: '教师管理', Grade: 2, parent: 1},
    // {id: 12, icon: '&#xe6d0;', name: '基地人员管理', Grade: 2, parent: 1},
    // {id: 13, icon: '&#xe6d0;', name: '实习大纲管理', Grade: 2, parent: 2},
    // {id: 14, icon: '&#xe6d0;', name: '实习制度管理', Grade: 2, parent: 2},
    // {id: 15, icon: '&#xe6d0;', name: '实习要求管理', Grade: 2, parent: 2},
    // {id: 16, icon: '&#xe6d0;', name: '实习检查要求管理', Grade: 2, parent: 2},
    // {id: 17, icon: '&#xe6d0;', name: '其他资料', Grade: 2, parent: 2},
    // {id: 18, icon: '&#xe6d0;', name: '考勤管理', Grade: 2, parent: 3},
    // {id: 19, icon: '&#xe6d0;', name: '审批管理', Grade: 2, parent: 3},
    // {id: 20, icon: '&#xe6d0;', name: '实习基地管理', Grade: 2, parent: 4},
    // {id: 21, icon: '&#xe6d0;', name: '实习小组管理', Grade: 2, parent: 4},
    // {id: 22, icon: '&#xe6d0;', name: '实习生管理', Grade: 2, parent: 4},
    // {id: 23, icon: '&#xe6d0;', name: '实习生明细管理', Grade: 2, parent: 4},
    // {id: 24, icon: '&#xe6d0;', name: '公告管理', Grade: 2, parent: 5},
    // {id: 25, icon: '&#xe6d0;', name: '通知管理', Grade: 2, parent: 5},
    // {id: 26, icon: '&#xe6d0;', name: '角色管理', Grade: 2, parent: 6},
    // {id: 27, icon: '&#xe6d0;', name: '账号管理', Grade: 2, parent: 6},
    // {id: 28, icon: '&#xe6d0;', name: '菜单管理', Grade: 2, parent: 6},
    // {id: 29, icon: '&#xe6d0;', name: '系统日志', Grade: 2, parent: 6},
    // {id: 30, icon: '&#xe6d0;', name: '基础配置', Grade: 2, parent: 6},
    // {id: 31, icon: '&#xe6d0;', name: '列表查询', Grade: 3, parent: 11},
    // {id: 32, icon: '&#xe6d0;', name: '班次管理', Grade: 3, parent: 18},
    // {id: 33, icon: '&#xe6d0;', name: '考勤组管理', Grade: 3, parent: 18},
    // {id: 34, icon: '&#xe6d0;', name: '考勤统计', Grade: 3, parent: 18},
    // {id: 35, icon: '&#xe6d0;', name: '审批模板管理', Grade: 3, parent: 19},
    // {id: 36, icon: '&#xe6d0;', name: '审批流程管理', Grade: 3, parent: 19},
    // {id: 37, icon: '&#xe6d0;', name: '审批', Grade: 3, parent: 19},
    // {id: 38, icon: '&#xe6d0;', name: '指派实习基地', Grade: 3, parent: 22},
    // {id: 39, icon: '&#xe6d0;', name: '指派科室', Grade: 3, parent: 22}
  ],
  menu_top_list: [],
  menu_left_list: [],
  top_active: {},
  menu_tree: []
}
// getters
const getters = {
  // 获得选中的顶部菜单
  active: (state) => {
    return state.top_active
  },
  // 获取顶部菜单
  getMenuTop: (state) => {
    return state.menu_top_list
  },
  // 获取左侧一级菜单
  getMenuLeft: (state) => {
    return state.menu_left_list
  },
  // 获取菜单树
  getMenuTree: (state) => {
    return state.menu_tree
  },
  // 获得子菜单
  getMenuLeftSubmenu: (state) => (id) => {
    if (state.list != null) {
      let l = state.list.filter(function (obj) {
        return obj.id === id
      }).concat(state.list.filter(function (obj) {
        return obj.mSupId === id
      }))
      return l
    } else {
      return []
    }
  }
}
// actions
const actions = {
  updatestatus ({ state, commit }) {
    commit('setstatus', false)
  }
}
// mutations
const mutations = {
  // 更新菜单
  update_menu_list (state, list) {
    state.list = list
  },
  // 更新一级菜单选择状态
  update_top_active (state, active) {
    state.top_active = active
  },
  // 更新顶部菜单
  update_menu_top_list (state, obj) {
    state.menu_top_list = obj
  },
  // 更新左侧菜单
  update_menu_left_list (state, obj) {
    state.menu_left_list = obj
  },
  // 更新菜单树
  update_menu_tree(state, obj) {
    state.menu_tree = obj
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/menu.js